function isVisible(el, partial = false) {
  const rect = el.getBoundingClientRect();
  const viewHeight = window.innerHeight || document.documentElement.clientHeight;
  const viewTop = 0;
  const viewBottom = viewHeight;

  const elTop = rect.top;
  const elBottom = rect.bottom;

  const compareTop = partial ? elBottom : elTop;
  const compareBottom = partial ? elTop : elBottom;

  return compareBottom <= viewBottom && compareTop >= viewTop;
}

// Assign IDs and transitions to sections & elements
document.querySelectorAll('.amimation-section').forEach((section, h) => {
  section.id = 'andi-main-' + (h + 1);
  let x = 1;

  section.querySelectorAll('.animation_element').forEach((el, i) => {
    const result = x / 5;
    el.id = 'andi-pal-' + (i + 1);
    el.style.transition = `0.7s ${result}s ease-in-out`;
    x++;
  });
});

// Add initial class
document.querySelectorAll('.animation_element').forEach(el => {
  el.classList.remove('animationClip');
});

// Scroll listener
window.addEventListener('scroll', () => {
  document.querySelectorAll('.animation_element').forEach(el => {
    if (isVisible(el, true)) {
      el.classList.add('animationClip');
    } 
  });
});

document.querySelectorAll('.contact-new .animation_element').forEach(el => {
  el.classList.add('animationClip');
});

document.querySelectorAll('.story-bnr .animation_element').forEach(el => {
  el.classList.add('animationClip');
});
document.querySelectorAll('.recipe-top .animation_element').forEach(el => {
  el.classList.add('animationClip');
});
document.querySelectorAll('.recipe-inner--wrap .animation_element').forEach(el => {
  el.classList.add('animationClip');
});

document.querySelectorAll('.main-prd .animation_element').forEach(el => {
  el.classList.add('animationClip');
});

document.querySelectorAll('.reviewpg-rev .animation_element').forEach(el => {
  el.classList.add('animationClip');
});


$("li header-menu  details").hover(function (){
    $(this).addClass("kkk").attr("open", true);
    $(this).children(".submenu").attr("aria-expanded",true);
  }, function (){
    $(this).removeClass("kkk").removeAttr("open", true);
    $(".header__menu-item").attr("aria-expanded",false);
});




